import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class SetDirector extends Component {
    state = {
        params: {},
        isEdit: true,
        visible: false,
        loading: false,
        userOptions: [],
    }

    show = (record) => {
        this.setState({
            params: { ...(record || {}) },
        }, () => {
            this.setState({
                visible: true,
            });
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            userOptions: [],
        });
    }

    submit = () => {
        const {
            params,
            params: {
                userId,
            },
            userOptions,
        } = this.state;
        if (userId) {
            const isExist = userOptions.some(item => item.value == userId);
            if (!isExist) {
                message.warning('请选择正确的医生');
                return;
            }
        } else {
            message.warning('请选择医生');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.addHospitalDepartmentUser,
            data: { ...params },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { params } = this.state;
        params[idName] = id;
        
        const option = options.find(i => i.userId == id) || {};
        const { doctorPosition, userMobile, userTelphone, userEmail } = option;
        params.doctorPosition  = doctorPosition || '';
        params.userMobile  = userMobile || '';
        params.userTelphone  = userTelphone || '';
        params.userEmail  = userEmail || '';

        this.setState({
            params,
            [optionsName]: options,
        });
    }

    render() {
        const { visible, loading, params } = this.state;
        const { chargePersonUserId, userCompellation, hospitalId, hospitalDepartmentId, doctorPosition, userMobile, userTelphone, userEmail  } = params;

        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title='配置行政负责人'
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                width="450px"
                maskClosable={false}
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">{asterisk}医生:</div>
                                <div className="item-right">
                                    {
                                        visible &&
                                        <HighSearchInput
                                            isEdit={true}
                                            keyword='keywords'
                                            style={{ width: 162 }}
                                            params={{ limit: 20, hospitalId, hospitalDepartmentId }}
                                            placeholder="输入姓名检索"
                                            url={API_URL.hospital.queryDoctorListByDepId}
                                            initValue={{ key: chargePersonUserId, label: userCompellation }}
                                            config={{ id: 'userId', name: 'userCompellation' }}
                                            onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'userId', 'userOptions')}
                                        />
                                    }
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">职务:</div>
                                <div className="item-right">{doctorPosition}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">手机号码:</div>
                                <div className="item-right">{userMobile}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">固定电话:</div>
                                <div className="item-right">{userTelphone}</div>
                            </li><li className="modal-item">
                                <div className="item-left">邮箱:</div>
                                <div className="item-right">{userEmail}</div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default SetDirector;


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/SetManager.js